import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { useLanguage, LangToggle } from '../context/LanguageContext'

export default function Register() {
  const { t } = useLanguage()
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [success, setSuccess] = useState(false)

  const handleRegister = async (e) => {
    e.preventDefault(); setLoading(true); setError('')
    const { error } = await supabase.auth.signUp({ email, password, options: { data: { full_name: fullName } } })
    if (error) setError(error.message)
    else setSuccess(true)
    setLoading(false)
  }

  if (success) return (
    <div className="auth-page">
      <div className="auth-box" style={{ textAlign: 'center' }}>
        <div style={{ fontSize: '3rem', marginBottom: '16px' }}>✅</div>
        <h2 style={{ marginBottom: '12px' }}>{t.accountCreated}</h2>
        <p style={{ color: 'var(--ash)', marginBottom: '24px' }}>{t.checkEmail}</p>
        <Link to="/login" className="btn-full" style={{ display: 'block', textAlign: 'center', textDecoration: 'none' }}>
          {t.signInBtn}
        </Link>
      </div>
    </div>
  )

  return (
    <div className="auth-page">
      <div className="auth-box">

        {/* Lang toggle */}
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
          <LangToggle />
        </div>

        <div className="auth-logo">
          <div className="auth-logo-icon">👑</div>
          <div className="auth-logo-name">{t.appName}</div>
        </div>
        <h1 className="auth-title">{t.createAccountTitle}</h1>
        <p className="auth-sub">{t.createAccountSub}</p>
        {error && <div className="error-msg">{error}</div>}
        <form onSubmit={handleRegister}>
          <div className="form-group">
            <label className="form-label" htmlFor="reg-name">{t.fullNameInput}</label>
            <input className="form-input" id="reg-name" type="text" placeholder={t.fullNameInput} value={fullName} onChange={e => setFullName(e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="reg-email">{t.emailLabel}</label>
            <input className="form-input" id="reg-email" type="email" placeholder="example@email.com" value={email} onChange={e => setEmail(e.target.value)} required />
          </div>
          <div className="form-group">
            <label className="form-label" htmlFor="reg-password">{t.passwordLabel}</label>
            <input className="form-input" id="reg-password" type="password" placeholder="8+" value={password} onChange={e => setPassword(e.target.value)} required minLength={8} />
          </div>
          <button className="btn-full" type="submit" disabled={loading}>
            {loading ? t.creatingAccount : t.createAccountBtn}
          </button>
        </form>
        <div className="auth-switch">{t.haveAccount} <Link to="/login">{t.signInLink}</Link></div>
      </div>
    </div>
  )
}
